export interface Movie {
  id: string;
  title: string;
  type: "movie" | "tv";
  theme: string;
  genres: string[];
  year: number;
  rating: number;
  region: string;
  director: string;
  cast: string;
  duration: string;
  summary: string;
  synopsis: string;
  tags: string[];
  cover: string;
  views: number;
  favorites: number;
}

export const movies: Movie[] = [
  {
    id: "1",
    title: "年轻的母亲",
    type: "movie",
    theme: "年轻的母亲",
    genres: ["剧情", "家庭"],
    year: 2019,
    rating: 8.7,
    region: "中国大陆",
    director: "陈晓宁",
    cast: "林静然 / 赵一鸣 / 王淑芬",
    duration: "118分钟",
    summary: "二十四岁失去丈夫的年轻母亲，用柔弱的肩膀独自撑起一个家，也重新学会爱自己。",
    synopsis:
      "二十六岁的苏晚在一场意外中失去了丈夫，留下年幼的女儿和一屋子未还清的账单。她白天在纺织厂做工，夜里替人缝补衣物，把所有的疲惫都留给自己。\n\n生活的重压之下，她既要面对婆家的不解，也要回应旁人异样的目光。但她始终没有放弃对女儿的爱，也没有放弃心中那个想成为服装设计师的梦。\n\n这既是一部关于母亲的电影，也是一部关于一个女人如何在困境中重新找回自己的故事。",
    tags: ["年轻的母亲", "催泪", "亲情", "女性成长"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20poster%20of%20a%20young%20mother%20gently%20holding%20her%20little%20daughter%20in%20soft%20golden%20afternoon%20light%2C%20emotional%20family%20drama%20mood%2C%20muted%20coral%20and%20amber%20color%20palette%2C%20elegant%20editorial%20composition%2C%20painterly%20film%20art%2C%20warm%20simple%20background&width=500&height=750&seq=ymm-poster-01&orientation=portrait",
    views: 128000,
    favorites: 9860,
  },
  {
    id: "2",
    title: "年轻的母亲2：回家的路",
    type: "movie",
    theme: "年轻的母亲",
    genres: ["剧情", "家庭"],
    year: 2021,
    rating: 8.4,
    region: "中国大陆",
    director: "陈晓宁",
    cast: "林静然 / 李安然 / 张岚",
    duration: "124分钟",
    summary: "时隔多年，苏晚带着女儿回到故乡，却发现最难走的路，是回到自己心里的那条路。",
    synopsis:
      "在城市打拼多年后，苏晚终于拥有了自己的小小服装工作室。然而母亲的病重让她不得不带着女儿回到那个曾让她伤心离开的小镇。\n\n故乡的街巷依旧，人却已经不同。旧日的误会、未说出口的歉意、以及那些被时间封存的秘密，在短短一个冬天里重新浮现。\n\n这是一段关于和解与回归的旅程，关于一个女儿、一位母亲，和她们各自的人生。",
    tags: ["年轻的母亲", "亲情", "故乡", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20young%20woman%20walking%20on%20a%20rural%20road%20with%20her%20daughter%20at%20sunset%2C%20nostalgic%20homecoming%20drama%20atmosphere%2C%20warm%20amber%20and%20terracotta%20tones%2C%20soft%20hazy%20background%2C%20film%20poster%20art%2C%20emotional%20and%20tender&width=500&height=750&seq=ymm-poster-02&orientation=portrait",
    views: 96500,
    favorites: 7420,
  },
  {
    id: "3",
    title: "年轻的母亲：都市日记",
    type: "tv",
    theme: "年轻的母亲",
    genres: ["剧情", "都市"],
    year: 2022,
    rating: 8.2,
    region: "中国大陆",
    director: "周以恒",
    cast: "沈若霖 / 高铭 / 郑雅琪",
    duration: "全 24 集",
    summary: "一位单亲妈妈在大城市的十年浮沉，记录下每一次跌倒与站起。",
    synopsis:
      "二十八岁的江予是广告公司里最拼的人，也是幼儿园门口总是最晚来接孩子的妈妈。她把一天掰成两半用，一半给工作，一半给女儿。\n\n在职场的偏见与生活的琐碎之间，她学会了拒绝、学会了求助，也学会了在深夜崩溃之后第二天照常上班。\n\n本剧以日记式的叙事，温柔而真实地记录了一个年轻母亲如何在都市里为自己和孩子争得一席之地。",
    tags: ["年轻的母亲", "都市", "职场", "单亲"],
    cover: "https://readdy.ai/api/search-image?query=Stylish%20TV%20series%20poster%20of%20a%20young%20professional%20mother%20in%20a%20modern%20city%20at%20dusk%2C%20blurred%20city%20lights%20in%20background%2C%20urban%20drama%20mood%2C%20warm%20coral%20and%20gold%20tones%2C%20minimal%20elegant%20composition%2C%20editorial%20poster%20art&width=500&height=750&seq=ymm-poster-03&orientation=portrait",
    views: 87300,
    favorites: 6510,
  },
  {
    id: "4",
    title: "年轻的母亲之逆光而行",
    type: "tv",
    theme: "年轻的母亲",
    genres: ["家庭", "爱情"],
    year: 2023,
    rating: 8.5,
    region: "中国大陆",
    director: "林书瑶",
    cast: "顾清和 / 白敬言 / 苏晴",
    duration: "全 32 集",
    summary: "被生活逼到墙角的她选择逆光而行，在流言与真情之间重新定义了“母亲”二字。",
    synopsis:
      "年轻母亲许安曾被一纸判决判为“不合格的母亲”，在所有人都不看好她的情况下，她一边打零工一边自学法律，只为把儿子接回身边。\n\n在这条逆光的路上，她遇到了愿意相信她的律师，也遭遇了最亲近之人的背叛。每一次选择都艰难，每一次前行都需要勇气。\n\n这是一部关于尊严、爱与坚持的剧集，献给所有在逆境中不肯低头的母亲。",
    tags: ["年轻的母亲", "成长", "励志", "情感"],
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20TV%20poster%20of%20a%20young%20mother%20standing%20against%20strong%20backlight%20with%20her%20child%2C%20determined%20expression%2C%20cinematic%20warm%20sunset%20glow%2C%20coral%20and%20amber%20gradient%20background%2C%20premium%20film%20poster%20style%2C%20emotional%20and%20hopeful&width=500&height=750&seq=ymm-poster-04&orientation=portrait",
    views: 105200,
    favorites: 8890,
  },
  {
    id: "5",
    title: "单亲妈妈的春天",
    type: "movie",
    theme: "年轻的母亲",
    genres: ["家庭", "爱情"],
    year: 2020,
    rating: 7.9,
    region: "中国大陆",
    director: "韩雪松",
    cast: "叶知秋 / 陆则言 / 罗小雨",
    duration: "106分钟",
    summary: "当一个年轻妈妈决定重新开始恋爱时，她要面对的，是整个世界的眼光。",
    synopsis:
      "离婚后的第五年，三十岁的方棠终于第一次为自己心动。对方是女儿的班主任，温柔而可靠，却也让这段关系变得格外复杂。\n\n她要面对孩子的情绪、前夫的纠缠、以及旁人“当妈了就该安分”的评头论足。她只是想要一点属于自己的春天。\n\n一部温暖轻快、又带着现实重量的都市情感电影。",
    tags: ["年轻的母亲", "爱情", "都市", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Romantic%20light%20movie%20poster%20of%20a%20young%20mother%20smiling%20in%20spring%20blossom%20park%20with%20her%20child%2C%20soft%20pastel%20warm%20tones%2C%20gentle%20bokeh%20flowers%20background%2C%20heartwarming%20romance%20drama%20mood%2C%20airy%20elegant%20composition&width=500&height=750&seq=ymm-poster-05&orientation=portrait",
    views: 74200,
    favorites: 5230,
  },
  {
    id: "6",
    title: "妈妈的第二次青春",
    type: "tv",
    theme: "年轻的母亲",
    genres: ["剧情", "家庭"],
    year: 2021,
    rating: 8.0,
    region: "中国大陆",
    director: "周以恒",
    cast: "温婉 / 何嘉树 / 陈念",
    duration: "全 28 集",
    summary: "孩子长大离家后，三十八岁的她决定为自己活一次。",
    synopsis:
      "把儿子送上大学的那天，林悦忽然发现，自己好像已经没有了自己。二十年来，她的日程表里写满了家人的名字。\n\n四十五岁重返校园、从零开始学画画、重新拾起年轻时的梦想，她笨拙却坚定地开始了自己的第二次青春。\n\n一部献给所有“妈妈”的成长故事：成为母亲，也永远可以是自己。",
    tags: ["年轻的母亲", "成长", "治愈", "女性"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20TV%20drama%20poster%20of%20a%20middle%20aged%20woman%20painting%20in%20a%20sunlit%20art%20studio%2C%20renewed%20sense%20of%20self%2C%20soft%20amber%20and%20cream%20tones%2C%20inspirational%20atmosphere%2C%20clean%20elegant%20composition%2C%20film%20poster%20art&width=500&height=750&seq=ymm-poster-06&orientation=portrait",
    views: 68900,
    favorites: 4720,
  },
  {
    id: "7",
    title: "早春的母亲",
    type: "movie",
    theme: "年轻的母亲",
    genres: ["剧情", "文艺"],
    year: 2018,
    rating: 8.6,
    region: "中国大陆",
    director: "苏牧",
    cast: "许清扬 / 柳岩青",
    duration: "112分钟",
    summary: "在江南早春的雾气里，一位年轻母亲与命运做了一场安静的告别。",
    synopsis:
      "故事发生在南方一个潮湿的小镇。年轻的母亲阿禾带着生病的孩子，在早春连绵的雨里往返于医院与家之间。\n\n她没有哭天抢地，只是把日子一天一天过下去：熬药、晾衣、在菜市场为几毛钱讲价。生活很重，她走得很慢，却从没有停下。\n\n一部克制而深情的文艺佳作，用长镜头与留白，讲述最朴素的母爱。",
    tags: ["年轻的母亲", "文艺", "亲情", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Poetic%20arthouse%20film%20poster%20of%20a%20young%20mother%20in%20misty%20southern%20town%20early%20spring%2C%20soft%20rain%20and%20green%20field%20tones%20with%20warm%20accents%2C%20melancholic%20tender%20atmosphere%2C%20refined%20minimal%20composition%2C%20painterly&width=500&height=750&seq=ymm-poster-07&orientation=portrait",
    views: 61300,
    favorites: 5540,
  },
  {
    id: "8",
    title: "年轻的母亲：雨夜来信",
    type: "movie",
    theme: "年轻的母亲",
    genres: ["悬疑", "剧情"],
    year: 2024,
    rating: 8.3,
    region: "中国大陆",
    director: "林书瑶",
    cast: "沈若霖 / 段奕辰 / 陈念",
    duration: "116分钟",
    summary: "一封没有署名的信，让年轻母亲重新翻开了一段被刻意遗忘的雨夜。",
    synopsis:
      "雨夜，年轻母亲程晚在家门口收到一封没有寄件人的信。信里只有一句话：“那天晚上，你看见的都不是真的。”\n\n为了弄清真相，她开始重新调查三年前的那场事故。每揭开一层，她就会发现，自己一直以为的过去，其实是被温柔地保护起来的谎言。\n\n一部关于母爱、秘密与宽恕的情感悬疑片。",
    tags: ["年轻的母亲", "悬疑", "亲情", "反转"],
    cover: "https://readdy.ai/api/search-image?query=Moody%20cinematic%20thriller%20poster%20of%20a%20young%20mother%20in%20a%20rainy%20night%20holding%20a%20letter%2C%20warm%20streetlight%20glow%20against%20deep%20teal%20shadows%2C%20mysterious%20emotional%20atmosphere%2C%20coral%20highlights%2C%20premium%20film%20poster%20art&width=500&height=750&seq=ymm-poster-08&orientation=portrait",
    views: 118700,
    favorites: 9120,
  },
  {
    id: "9",
    title: "山海之城",
    type: "tv",
    theme: "都市悬疑",
    genres: ["剧情", "悬疑"],
    year: 2023,
    rating: 8.8,
    region: "中国大陆",
    director: "陆知白",
    cast: "江淮 / 许安安 / 周牧",
    duration: "全 36 集",
    summary: "一座临海小城的旧案，牵出十年间几代人的秘密与选择。",
    synopsis:
      "刑警江淮回到故乡调查一桩尘封十年的旧案，却在调查中发现，案件的每一个相关者，都与这座城市的现在息息相关。\n\n随着真相一点点浮出水面，他不得不面对一个艰难的问题：有些真相，究竟是为了谁而隐瞒？\n\n一部格局宏大、节奏紧凑的年度悬疑口碑之作。",
    tags: ["悬疑", "都市", "口碑"],
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20crime%20drama%20poster%20of%20a%20coastal%20city%20at%20dusk%20with%20a%20lone%20detective%20silhouette%2C%20deep%20indigo%20harbor%20with%20warm%20orange%20street%20lights%2C%20moody%20cinematic%20mystery%20tone%2C%20premium%20key%20art&width=500&height=750&seq=ymm-poster-09&orientation=portrait",
    views: 143600,
    favorites: 11230,
  },
  {
    id: "10",
    title: "追风少年",
    type: "movie",
    theme: "青春运动",
    genres: ["青春", "运动"],
    year: 2022,
    rating: 7.8,
    region: "中国大陆",
    director: "韩雪松",
    cast: "顾南舟 / 林一辰 / 白露",
    duration: "108分钟",
    summary: "一个来自小城的少年，靠一双旧跑鞋，跑出了属于自己的人生赛道。",
    synopsis:
      "十七岁的陈野从没离开过自己的小镇，却梦想着站上更大的赛场。他只有一双磨破的跑鞋和一个不肯认输的念头。\n\n在教练与同伴的帮助下，他一步步从校运会跑到省赛，也在奔跑中理解了坚持的真正含义。\n\n一部热血而不说教的青春励志电影。",
    tags: ["青春", "励志", "热血"],
    cover: "https://readdy.ai/api/search-image?query=Energetic%20sports%20movie%20poster%20of%20a%20teenage%20boy%20running%20on%20a%20track%20at%20golden%20hour%2C%20motion%20blur%20and%20warm%20sunlight%2C%20youthful%20hopeful%20mood%2C%20amber%20and%20sky%20tones%2C%20dynamic%20cinematic%20composition&width=500&height=750&seq=ymm-poster-10&orientation=portrait",
    views: 82100,
    favorites: 4980,
  },
  {
    id: "11",
    title: "深巷食光",
    type: "tv",
    theme: "治愈美食",
    genres: ["治愈", "美食"],
    year: 2024,
    rating: 8.9,
    region: "中国大陆",
    director: "温以宁",
    cast: "老陈 / 苏晓 / 阿福",
    duration: "全 20 集",
    summary: "一条老街，一家小馆，用一日三餐，抚慰每一个深夜归来的人。",
    synopsis:
      "在城市的深巷里，有一家只在傍晚开门的小饭馆。老板老陈话不多，却记得每位熟客的口味和心事。\n\n每一集，都围绕一道家常菜，讲述一个普通人的故事：加班的年轻人、思念故乡的旅人、多年未见的老友。\n\n一部慢节奏、高治愈的暖心剧集，适合在疲惫时慢慢品味。",
    tags: ["治愈", "美食", "温暖"],
    cover: "https://readdy.ai/api/search-image?query=Cozy%20healing%20food%20drama%20poster%20of%20a%20small%20lantern%20lit%20noodle%20shop%20in%20a%20narrow%20alley%20at%20night%2C%20steaming%20dishes%20and%20warm%20lamp%20glow%2C%20comforting%20amber%20tones%2C%20inviting%20cinematic%20atmosphere&width=500&height=750&seq=ymm-poster-11&orientation=portrait",
    views: 137400,
    favorites: 12680,
  },
  {
    id: "12",
    title: "沉默的证人",
    type: "movie",
    theme: "犯罪悬疑",
    genres: ["悬疑", "犯罪"],
    year: 2021,
    rating: 8.1,
    region: "中国大陆",
    director: "陆知白",
    cast: "段奕辰 / 苏晴 / 高铭",
    duration: "114分钟",
    summary: "当唯一的目击者选择沉默，真相还能被听见吗？",
    synopsis:
      "一场雨夜的车祸，带走了一个人的生命，也带走了唯一的目击证人。警方在有限的线索中艰难推进，却发现每个证词都指向不同的方向。\n\n随着调查深入，一个关于恐惧与良知的复杂真相逐渐浮现。沉默，有时是懦弱，有时却是最深的自保。\n\n节奏紧凑、反转不断的犯罪悬疑佳作。",
    tags: ["悬疑", "犯罪", "反转"],
    cover: "https://readdy.ai/api/search-image?query=Dark%20crime%20thriller%20movie%20poster%20with%20a%20lone%20silhouette%20under%20a%20streetlamp%20in%20rain%2C%20cold%20slate%20blue%20shadows%20with%20a%20single%20warm%20orange%20light%2C%20tense%20mysterious%20mood%2C%20minimal%20premium%20key%20art&width=500&height=750&seq=ymm-poster-12&orientation=portrait",
    views: 91800,
    favorites: 6740,
  },
  {
    id: "13",
    title: "星海彼岸",
    type: "movie",
    theme: "科幻冒险",
    genres: ["科幻", "冒险"],
    year: 2023,
    rating: 8.4,
    region: "中国大陆",
    director: "苏牧",
    cast: "江澜 / 陆星野 / 何嘉树",
    duration: "136分钟",
    summary: "当地球不再适合居住，人类把最后的希望，寄托在星海的另一端。",
    synopsis:
      "公元 2189 年，地球资源几近枯竭，人类启动了“彼岸计划”，向遥远星际寻找新的家园。领航员江澜肩负着全人类的期望，踏上了一条有去无回的旅途。\n\n在漫长的星际航行中，她不仅要面对未知的宇宙，也要面对内心深处的孤独与选择。\n\n一部兼具宏大想象与细腻情感的科幻史诗。",
    tags: ["科幻", "冒险", "视觉"],
    cover: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20of%20an%20astronaut%20gazing%20at%20a%20distant%20glowing%20planet%20through%20a%20spaceship%20window%2C%20deep%20navy%20space%20with%20warm%20golden%20nebula%20accents%2C%20awe%20inspiring%20cinematic%20scale%2C%20premium%20blockbuster%20key%20art&width=500&height=750&seq=ymm-poster-13&orientation=portrait",
    views: 156900,
    favorites: 10240,
  },
  {
    id: "14",
    title: "长夜将尽",
    type: "tv",
    theme: "都市悬疑",
    genres: ["悬疑", "剧情"],
    year: 2022,
    rating: 8.6,
    region: "中国大陆",
    director: "周以恒",
    cast: "许安安 / 江淮 / 陈念",
    duration: "全 30 集",
    summary: "最漫长的夜里，总有人愿意为天亮守住最后一盏灯。",
    synopsis:
      "记者许安追踪一起被掩盖多年的案件，越接近真相，危险就越逼近。她的坚持，触碰到了太多人的利益。\n\n在长夜般的困局中，她遇到了愿意并肩的人，也看清了谁在暗中守护。真相或许迟到，但从不缺席。\n\n一部兼顾社会议题与人性刻画的高分剧集。",
    tags: ["悬疑", "都市", "口碑"],
    cover: "https://readdy.ai/api/search-image?query=Noir%20TV%20series%20poster%20of%20a%20female%20journalist%20in%20a%20long%20dark%20night%20city%2C%20a%20single%20warm%20lamp%20glowing%2C%20moody%20teal%20shadows%20with%20amber%20light%2C%20suspenseful%20elegant%20composition%2C%20premium%20key%20art&width=500&height=750&seq=ymm-poster-14&orientation=portrait",
    views: 112500,
    favorites: 8760,
  },
  {
    id: "15",
    title: "花间一壶酒",
    type: "tv",
    theme: "古装爱情",
    genres: ["古装", "爱情"],
    year: 2023,
    rating: 8.2,
    region: "中国大陆",
    director: "温以宁",
    cast: "柳岩青 / 白敬言 / 郑雅琪",
    duration: "全 40 集",
    summary: "一壶桃花酿，一诺半生缘，在乱世里写下一段温柔传奇。",
    synopsis:
      "江南酒坊的女儿阿酒，因一壶祖传桃花酿卷入朝堂风云。她不过是个想把生意做好的寻常女子，却一步步被推向了时代的漩涡。\n\n在权谋与真情之间，她与一位落魄公子相知相守，也用自己的方式护住了一方烟火。\n\n画面唯美、情感细腻的古装爱情剧，桃花与人情同样醉人。",
    tags: ["古装", "爱情", "唯美"],
    cover: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20poster%20of%20a%20young%20woman%20in%20traditional%20hanfu%20holding%20a%20wine%20jar%20among%20blooming%20peach%20blossoms%2C%20soft%20warm%20pink%20and%20amber%20tones%2C%20poetic%20romantic%20atmosphere%2C%20refined%20artistic%20composition&width=500&height=750&seq=ymm-poster-15&orientation=portrait",
    views: 98400,
    favorites: 7290,
  },
  {
    id: "16",
    title: "我们的冬牧场",
    type: "movie",
    theme: "纪录剧情",
    genres: ["纪录", "剧情"],
    year: 2020,
    rating: 8.9,
    region: "中国大陆",
    director: "苏牧",
    cast: "巴特尔 / 其其格 / 小乌云",
    duration: "102分钟",
    summary: "在零下三十度的冬日草原上，一个家庭用最朴素的方式守护着彼此与牛群。",
    synopsis:
      "影片跟随一户草原牧民家庭，记录下他们一整个冬天的迁徙与生活。全片几乎没有旁白，只有风声、炉火和一家人的日常对话。\n\n在极寒与孤寂中，他们用默契与爱维系着整个家。那种平静而坚韧的力量，足以让每一位观者动容。\n\n一部以纪录之眼书写亲情的温柔之作。",
    tags: ["纪录", "亲情", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Documentary%20film%20poster%20of%20a%20nomadic%20family%20on%20snowy%20winter%20grassland%20at%20dawn%2C%20warm%20glow%20from%20a%20yurt%20against%20pale%20blue%20snow%2C%20quiet%20tender%20atmosphere%2C%20cinematic%20wide%20composition%2C%20authentic%20tone&width=500&height=750&seq=ymm-poster-16&orientation=portrait",
    views: 54200,
    favorites: 4310,
  },
  {
    id: "17",
    title: "蓝调咖啡馆",
    type: "tv",
    theme: "都市爱情",
    genres: ["都市", "爱情"],
    year: 2024,
    rating: 7.7,
    region: "中国大陆",
    director: "林书瑶",
    cast: "陈念 / 顾南舟 / 苏晓",
    duration: "全 24 集",
    summary: "一间深夜营业的咖啡馆，几个不愿睡去的人，和他们的心事。",
    synopsis:
      "午夜十二点，蓝调咖啡馆亮起暖灯。店主苏晓习惯为深夜里独坐的客人留一个位置，也习惯倾听他们不愿对白天说的心事。\n\n每一位深夜来客，都带着自己的故事：失恋的歌手、赶稿的作家、久别重逢的旧友。他们在咖啡的香气里，慢慢学会与自己和解。\n\n一部节奏舒缓、氛围迷人的都市群像剧。",
    tags: ["都市", "爱情", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Cozy%20urban%20romance%20poster%20of%20a%20warm%20midnight%20coffee%20shop%20interior%20with%20glowing%20lamps%20and%20a%20steaming%20cup%2C%20amber%20and%20deep%20brown%20tones%2C%20intimate%20cinematic%20atmosphere%2C%20elegant%20composition&width=500&height=750&seq=ymm-poster-17&orientation=portrait",
    views: 76300,
    favorites: 5120,
  },
  {
    id: "18",
    title: "归途列车",
    type: "movie",
    theme: "公路剧情",
    genres: ["剧情", "公路"],
    year: 2019,
    rating: 8.0,
    region: "中国大陆",
    director: "韩雪松",
    cast: "赵一鸣 / 许清扬 / 罗小雨",
    duration: "110分钟",
    summary: "一趟穿越半个中国的绿皮火车的旅途，载着两个陌生人的和解与释怀。",
    synopsis:
      "春节前夕，一列开往北方的绿皮火车上，两个素不相识的人因为一张错位的车票而相识。\n\n一路上，他们聊起各自的家庭、遗憾与未竟的心愿。漫长的旅途终有终点，但他们都在对方的故事里，找到了回家的方向。\n\n一部温暖克制、余味悠长的公路剧情片。",
    tags: ["剧情", "公路", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20road%20movie%20poster%20of%20a%20green%20train%20crossing%20a%20vast%20golden%20landscape%20at%20sunset%2C%20two%20passengers%20by%20the%20window%2C%20nostalgic%20amber%20and%20ochre%20tones%2C%20bittersweet%20cinematic%20atmosphere&width=500&height=750&seq=ymm-poster-18&orientation=portrait",
    views: 66400,
    favorites: 4580,
  }
];

export const heroSlides = [
  {
    id: "1",
    title: "年轻的母亲",
    subtitle: "用柔弱的肩膀，独自撑起一个家",
    meta: "2019 · 剧情 / 家庭 · 评分 8.7",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20young%20mother%20holding%20her%20daughter%20in%20soft%20golden%20afternoon%20light%20on%20a%20quiet%20street%2C%20emotional%20family%20drama%20mood%2C%20muted%20coral%20and%20amber%20palette%2C%20gentle%20bokeh%2C%20editorial%20film%20still%2C%20room%20for%20text%20on%20left%20side&width=1600&height=720&seq=hero-ymm-01&orientation=landscape",
  },
  {
    id: "8",
    title: "年轻的母亲：雨夜来信",
    subtitle: "那晚的真相，被温柔地藏了三年",
    meta: "2024 · 悬疑 / 剧情 · 评分 8.3",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20wide%20scene%20of%20a%20young%20mother%20standing%20under%20a%20streetlamp%20on%20a%20rainy%20night%20holding%20a%20letter%2C%20warm%20amber%20streetlight%20against%20deep%20teal%20rain%2C%20emotional%20mystery%20tone%2C%20film%20still%20with%20space%20for%20text%20on%20left&width=1600&height=720&seq=hero-ymm-02&orientation=landscape",
  },
  {
    id: "4",
    title: "年轻的母亲之逆光而行",
    subtitle: "在流言与真情之间，重新定义“母亲”",
    meta: "2023 · 家庭 / 爱情 · 评分 8.5",
    image:
      "https://readdy.ai/api/search-image?query=Backlit%20cinematic%20wide%20scene%20of%20a%20determined%20young%20mother%20with%20her%20child%20walking%20toward%20a%20glowing%20sunrise%2C%20warm%20coral%20and%20amber%20gradient%20sky%2C%20hopeful%20emotional%20atmosphere%2C%20film%20still%20with%20space%20for%20text%20on%20left&width=1600&height=720&seq=hero-ymm-03&orientation=landscape",
  }
];